export const G_CALENDAR_LINK = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ3KgXP8WDfRbZES6X594BKODFcfzss1ga5gpWLFkTo1PQGsQhqDne1lddwH4Z1KeWjIUARwxDru';
